//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { PayrollType } from './Enums';

export abstract class PayrollInputItem extends ItemBase {
    PayrollType: PayrollType = PayrollType.Income;
    TeacherID: string | null = null;
    Date: string = "1970-01-01T00:00:00";
    Amount: number = 0;
    Comment: string | null = null;

    static readonly ClassName: string = "PayrollInputItem";
}
